'use strict'

import {createScapiFetch} from './utils'

/**
 * OutletCustomApi provides methods to interact with the outlet campaign API, including fetching campaign status and outlet configurations.
 *
 * @class
 * @param {Object} config - Configuration object for initializing the API client.
 *
 * @method getCampaignStatus
 *   Fetches the current campaign status for a given site and locale.
 *   @param {string} accessToken - Access token for API authentication.
 *   @param {string} siteId - Identifier for the target site.
 *   @param {string} locale - Locale identifier (e.g., 'en-US').
 *   @returns {Promise<Object>} - Resolves to the campaign status object, or an empty object on error.
 *
 * @method getOutletConfigurations
 *   Retrieves outlet configuration data for a specific site and locale.
 *   @param {string} accessToken - Access token for API authentication.
 *   @param {string} siteId - Identifier for the target site.
 *   @param {string} locale - Locale identifier (e.g., 'en-US').
 *   @returns {Promise<Object>} - Resolves to the outlet configurations object, or an empty object on error.
 */
class OutletCustomApi {
    constructor(config) {
        this.config = config
        this.fetch = createScapiFetch(config)
    }

    async getCampaignStatus(accessToken, siteId, locale) {
        const urlParam = {
            querystring: {}
        }

        const endpoint = 'campaign-status'
        const method = 'POST'
        const args = [urlParam]
        const methodName = 'campaign-status'
        const requestParams = {
            apiPath: 'outlet-campaign',
            accessToken: accessToken,
            isCached: false,
            siteID: siteId,
            localeID: locale
        }
        const apiVersion = 'v1'

        try {
            const getCampaignStatus = await this.fetch(
                endpoint,
                method,
                args,
                methodName,
                requestParams,
                apiVersion
            )

            return getCampaignStatus || {}
        } catch (error) {
            console.error('Error fetching outlet campaign status:', error)
            return {}
        }
    }
}

export default OutletCustomApi
